import { useState, useEffect } from 'react';

const useWindowSize = () => {
  const isClient = typeof window === 'object';

  const getSize = () => {
    const width = isClient ? window.innerWidth : -1;
    const height = isClient ? window.innerHeight : -1;
    const isMobile = width < 768;
    const isDesktop = !isMobile;

    return {
      width,
      height,
      isMobile,
      isDesktop,
    };
  };

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    if (!isClient) {
      return false;
    }

    const handleResize = () => {
      setWindowSize(getSize());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

export default useWindowSize;
